import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface FirmwareGroupAssignState {
  isLoading: boolean
  error: string | undefined
  httpStatus: number | undefined
}

export const initialState: FirmwareGroupAssignState = {
  isLoading: false,
  error: undefined,
  httpStatus: undefined
}

const firmwareGroupAssignSlice = createSlice({
  name: 'firmware-group-assign',
  initialState,
  reducers: {
    firmwareGroupAssignLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        httpStatus: 0
      }
    },
    firmwareGroupAssignUpdateAction: (
      state,
      action: PayloadAction<number>
    ) => {
      return {
        isLoading: false,
        error: undefined,
        httpStatus: action.payload
      }
    },
    firmwareGroupAssignErrorAction: (
      state,
      action: PayloadAction<{ errorMessage: string, httpStatus: number }>
    ) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  firmwareGroupAssignLoadingAction,
  firmwareGroupAssignUpdateAction,
  firmwareGroupAssignErrorAction
} = firmwareGroupAssignSlice.actions

export default firmwareGroupAssignSlice.reducer
